var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { fontFamily, fontWeight } from "core/styles/snippets";
var Paragraph = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "regular" : _b;
    return React.createElement(ParagraphStyled, { variant: variant }, children);
};
export default Paragraph;
var variantToFontSize = function (variant) {
    return variant === "regular" ? "font-size: 1rem;" : "font-size: 0.875rem;";
};
var ParagraphStyled = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  line-height: 1.5;\n  ", "\n  ", "\n  ", ";\n"], ["\n  display: block;\n  width: 100%;\n  line-height: 1.5;\n  ", "\n  ", "\n  ", ";\n"])), fontFamily.base, fontWeight.light, function (props) { return variantToFontSize(props.variant); });
var templateObject_1;
